<template>
  <FaIcon :icon="['fas', ICON.LAYER_GROUP]" />
</template>

<script setup lang="ts">
import { ICON } from '@/constants/icons';

defineOptions({ name: 'PartitionIcon' });
</script>
